require('./ynet_yplus_site_logoutPopupComponent.less')

export class LogoutPopupComponent extends React.Component<{ closeLogoutPopupOpen, logOutFromPopUp, isPianoLogin?: boolean }, {}> {
    render() {
        return (
            <div className={`LogoutPopupComponent ${this.props.isPianoLogin ? "" : "newPaywall"}`}>
                <div className="LogoutPopup">
                    <div className="yedioth-plus-icon"></div>
                    <div className="text-content">בחרת להתנתק מהמשתמש שלך.
                        <span>האם להמשיך?</span>
                    </div>
                    <div className="ButtonsWrapper">
                        <button onClick={this.props.closeLogoutPopupOpen} className="ReturnButton">חזור</button>
                        <button onClick={this.props.logOutFromPopUp} className="LogoutButton">כן, התנתק</button>
                    </div>
                </div>
            </div>
        )
    }
}